import { render, staticRenderFns } from "./ProfileHome.vue?vue&type=template&id=97cdcd76&scoped=true"
import script from "./ProfileHome.vue?vue&type=script&lang=js"
export * from "./ProfileHome.vue?vue&type=script&lang=js"
import style0 from "./ProfileHome.vue?vue&type=style&index=0&id=97cdcd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cdcd76",
  null
  
)

export default component.exports